import { Text, Badge, Card, Heading, Inline, LinkButton, RadioCard, vars, textVariants, Stack } from '@etg/wings';
import { ScreenReaderPrice } from '@eti/components';
import { Check } from '@phosphor-icons/react';
import { AncillaryOption, TransferType } from '@eti/schema-types';
import { css } from '@eti/styles';
import { convertToHoursAndMinutes, getCardValidityText, getValidityKind, ValidityKind } from './utils';
import RouteStops from './RouteStops';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const cardWrapper = css`
  display: grid;
  grid-template-rows: auto 1fr auto;
`;
const priceStyles = css`
  display: flex;
  justify-content: end;
`;
const cardBodyWrapper = css`
  > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;
const badgeStyles = css`
  border-radius: 8px;
  padding: 4px 8px;
`;
const CheckedItem = props => /*#__PURE__*/_jsxs(Inline, {
  alignY: "center",
  as: "li",
  "data-testid": props.testId,
  noWrap: true,
  spacing: 8,
  children: [/*#__PURE__*/_jsx(Check, {
    "aria-hidden": true,
    color: vars.colors.signal.positive.foreground,
    size: "1.25rem"
  }), props.children]
});
const OperatorCardBody = ({
  operator,
  translation,
  handleOpenDrawer,
  hidePrice
}) => {
  const {
    ancillaryOption,
    transferTime,
    transferType,
    price,
    transferBoundData
  } = operator;
  const {
    cheapest,
    fastest,
    bus,
    train,
    transfer,
    hour,
    hours,
    minute,
    minutes,
    transferTime: transferTimeLabel,
    seeDetails,
    perPerson,
    departs,
    from,
    to
  } = translation;
  const validityKind = getValidityKind(operator);
  const ticketValidityText = getCardValidityText(operator, translation);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Card.Section, {
      className: cardBodyWrapper,
      children: [ancillaryOption && /*#__PURE__*/_jsx(Inline, {
        alignY: "center",
        as: "li",
        noWrap: true,
        spacing: 8,
        children: /*#__PURE__*/_jsx(Badge, {
          className: badgeStyles,
          "data-testid": "ancillary-option",
          children: ancillaryOption === AncillaryOption.Cheapest ? cheapest : fastest
        })
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: 8,
        children: [/*#__PURE__*/_jsx(CheckedItem, {
          testId: "transfer-type",
          children: `${transferType === TransferType.Bus ? bus : train} ${transfer}`
        }), /*#__PURE__*/_jsx(CheckedItem, {
          testId: "transfer-time",
          children: convertToHoursAndMinutes(transferTime !== null && transferTime !== void 0 ? transferTime : 0, hour, hours, minute, minutes, transferTimeLabel)
        })]
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: 8,
        children: [/*#__PURE__*/_jsx(RouteStops, {
          bounds: transferBoundData,
          departsText: departs,
          fromText: from,
          showDepartureTime: validityKind === ValidityKind.TimeSpecific,
          toText: to
        }), ticketValidityText && /*#__PURE__*/_jsx(Text, {
          "data-testid": "ticket-validity",
          children: ticketValidityText
        })]
      }), /*#__PURE__*/_jsx(LinkButton, {
        onClick: () => {
          handleOpenDrawer(operator);
        },
        children: seeDetails
      })]
    }), !hidePrice && /*#__PURE__*/_jsx(Card.Section, {
      children: /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        className: priceStyles,
        noWrap: true,
        spacing: 8,
        children: [/*#__PURE__*/_jsx(Text, {
          children: perPerson
        }), /*#__PURE__*/_jsx(Text, {
          "aria-hidden": true,
          "data-testid": "operator-price",
          variant: textVariants._18_EMPHASIZED,
          children: price
        }), /*#__PURE__*/_jsx(ScreenReaderPrice, {
          price: price
        })]
      })
    })]
  });
};
const OperatorCard = ({
  operator,
  translation,
  handleOpenDrawer
}) => {
  const {
    transferCarrier,
    externalChoiceId
  } = operator;
  return /*#__PURE__*/_jsx(RadioCard, {
    className: cardWrapper,
    "data-testid": "choice-container",
    id: `choice-${externalChoiceId}`,
    label: /*#__PURE__*/_jsx(Heading, {
      as: "span",
      level: 3,
      children: transferCarrier
    }),
    value: String(externalChoiceId),
    children: /*#__PURE__*/_jsx(OperatorCardBody, {
      handleOpenDrawer: handleOpenDrawer,
      operator: operator,
      translation: translation
    })
  });
};
const standaloneCardStyles = css`
  border: 0.0625rem solid ${vars.colors.divider};
  border-radius: ${vars.card.borderRadius};
  display: grid;
  grid-template-rows: auto 1fr;
`;
export const OperatorCardStandalone = ({
  operator,
  translation,
  handleOpenDrawer
}) => {
  const {
    transferCarrier
  } = operator;
  return /*#__PURE__*/_jsxs(Card, {
    className: standaloneCardStyles,
    "data-testid": "choice-container",
    children: [/*#__PURE__*/_jsx(Card.Section, {
      children: /*#__PURE__*/_jsx(Heading, {
        as: "span",
        level: 3,
        children: transferCarrier
      })
    }), /*#__PURE__*/_jsx(OperatorCardBody, {
      handleOpenDrawer: handleOpenDrawer,
      hidePrice: true,
      operator: operator,
      translation: translation
    })]
  });
};
export default OperatorCard;
//# sourceMappingURL=OperatorCard.js.map